import React, { useEffect } from "react";
import { IntlProvider } from "react-intl";
import { BrowserRouter as Router } from "react-router-dom";
import { useAppState } from "src/app/state/StateProvider";
import AppMonEspacePriveContent from "./AppMonEspacePriveContent";

/**
 * MonEspacePrive app entry point.
 *
 * Root component in charge of setting up the overall application
 * structure, including the top and left menus as well as i18n.
 */
export default function AppMonEspacePrive() {
  const [state] = useAppState();

  const [{ configuration }] = useAppState();
  const selectLogo = () => {
      return "favicon.ico";
  };

  useEffect(() => {
    let link: HTMLLinkElement | null = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.getElementsByTagName("head")[0].appendChild(link);
    }
    link.href = "/" + selectLogo();
  }, [configuration]);

  return (
    <IntlProvider
      locale={state.langue}
      defaultLocale="fr"
      messages={state.traductions}
    >
      <Router>
        <AppMonEspacePriveContent/>
      </Router>
    </IntlProvider>
  );
}
